module.exports = __webpack_public_path__ + "img/heart-blue.9a92dc68.svg";